<template>
  <div v-if="isAuthenticated">
    <Loader />

    <div id="content-except-loader">
      <!-- begin::Body -->
      <!-- begin:: Aside Left -->
      <KTAside v-if="asideEnabled"></KTAside>
      <!-- end:: Aside Left -->

      <!-- begin:: Header -->
      <div class="header-navbar-shadow"></div>
      <KTHeader></KTHeader>
      <!-- end:: Header -->

      <!-- begin:: Content -->
      <div class="app-content content">
        <div class="content-overlay"></div>
        <KTSubheader
          v-if="subheaderDisplay"
          v-bind:breadcrumbs="breadcrumbs"
          v-bind:title="pageTitle"
        />
        <!-- end:: Content Head -->

        <!-- begin:: Content Body -->
        <div class="content-body">
          <transition name="fade-in-up">
            <router-view />
          </transition>
        </div>
      </div>
      <KTFooter></KTFooter>

      <KTStickyToolbar v-if="false && toolbarDisplay"></KTStickyToolbar>
      <KTScrollTop v-if="false"></KTScrollTop>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import KTAside from "@/view/layout/aside/Aside.vue";
import KTHeader from "@/view/layout/header/Header.vue";
import KTHeaderMobile from "@/view/layout/header/HeaderMobile.vue";
import KTFooter from "@/view/layout/footer/Footer.vue";
import HtmlClass from "@/core/services/htmlclass.service";
import KTSubheader from "@/view/layout/subheader/Subheader.vue";
import KTStickyToolbar from "@/view/layout/extras/StickyToolbar.vue";
import KTScrollTop from "@/view/layout/extras/ScrollTop";
import Loader from "@/view/content/Loader.vue";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import moduleUser, {
  GET_SELF,
  MODULE_NAME as MODULE_USER,
  SELF,
} from "@/core/services/store/user.module";
import store from "@/core/services/store";

const _MODULE_USER = MODULE_USER;

export default {
  name: "Layout",
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_MODULE_USER, moduleUser);
  },
  components: {
    KTAside,
    KTHeader,
    KTHeaderMobile,
    KTFooter,
    KTSubheader,
    KTStickyToolbar,
    KTScrollTop,
    Loader,
  },
  beforeMount() {
    // show page loading
    this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");

    // initialize html element classes
    HtmlClass.init(this.layoutConfig());
  },
  mounted() {
    // check if current user is authenticated
    if (this.isAuthenticated) {
      this.getUser();
    } else if (!this.isAuthenticated) {
      this.$router.push({ name: "login" });
    }
  },
  methods: {
    getUser() {
      this.$store.dispatch(_MODULE_USER + "/" + GET_SELF).then(() => {
        $(document)
          .find("#loader")
          .attr("style", "height: 100vh; display: none !important");
        $(document).find("#content-except-loader").removeClass("content-blur");
      });
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
    ]),
    user() {
      return this.$store.getters[_MODULE_USER + "/" + SELF];
    },

    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },

    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },

    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },

    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      return !!this.layoutConfig("toolbar.display");
    },

    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
  },
};
</script>


<style scoped>
html,
body {
  background: none;
}
</style>
